import { Action } from 'helpers/action-helpers';
import { AppState } from '../../pages/app/state';
import { connect, Dispatch } from 'react-redux';
import { ResetPasswordAction } from 'pages/user-management/actions';
import { tenantSelector } from 'pages/settings/selectors';
import { UserForm as UF } from './component';
import { UserFormConnectedProps, UserFormConnectedActionProps } from './props';
import { permissionsSelector } from 'pages/login/selectors';
import { connectionSelector } from 'components/connection-status/selectors';

function mapStateToProps(state: AppState): UserFormConnectedProps {
  return {
    isOnline: connectionSelector(state),
    language: tenantSelector(state).language,
    isPasswordResetSuccess: state.userManagement.passwordResetSuccess,
    passwordResetErrorMessage: state.userManagement.passwordResetErrorMessage,
    permissions: permissionsSelector(state)
  };
}

function mapDispatchToProps(dispatch: Dispatch<Action>): UserFormConnectedActionProps {
  return {
    sendPasswordReset: (userEmail: string) => dispatch(new ResetPasswordAction(userEmail))
  };
}

export const UserForm = connect(mapStateToProps, mapDispatchToProps)(UF);


// WEBPACK FOOTER //
// ./src/components/user-form/index.ts